// extracted by mini-css-extract-plugin
export var attribution = "_7e-4";
export var authorName = "_7e-5";
export var quote = "_7e-3";
export var testimonial = "_7e-2";
export var trustedBy = "_7e-0";
export var trustedByLabel = "_7e-1";